import { useEffect, useState } from 'react';
import { Alert } from '@dreamtree-org/twreact-ui';
import PageShell from '@/components/layout/PageShell';
import PageHeader from '@/components/layout/PageHeader';
import DataTable from '@/components/DataTable';
import { platformGet, errorOf } from './platformApi';

/** P11 — redacted platform event history (secrets are scrubbed before they are stored). */
export default function PlatformAudit() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    platformGet('/audit', { limit: 500 }).then(setRows).catch((ex) => setErr(errorOf(ex).message));
  }, []);

  const columns = [
    { key: 'occurred_at', label: 'When', render: (r) => new Date(r.occurred_at).toLocaleString() },
    { key: 'action', label: 'Action', render: (r) => <code className="text-xs">{r.action}</code> },
    { key: 'actor_ref', label: 'Actor', render: (r) => `${r.actor_realm}:${r.actor_ref}` },
    { key: 'target', label: 'Target' },
    { key: 'company_id', label: 'Company', render: (r) => (r.company_id ? <code className="text-xs">{r.company_id.slice(0, 8)}</code> : '—') },
    {
      key: 'diff_redacted', label: 'Detail', searchable: false,
      render: (r) => (r.diff_redacted ? <code className="text-xs break-all">{typeof r.diff_redacted === 'string' ? r.diff_redacted : JSON.stringify(r.diff_redacted)}</code> : ''),
    },
  ];

  return (
    <PageShell className="space-y-3">
      <PageHeader title="Audit" subtitle="Platform configuration, lifecycle and sign-in events." />
      {err && <Alert variant="error">{err}</Alert>}
      <DataTable data={rows} columns={columns} search={{ placeholder: 'Search events…', keys: ['action', 'actor_ref', 'target'] }} pageSize={50} emptyText="No events yet." />
    </PageShell>
  );
}
